import React, {useEffect} from 'react';
import {View, Image, ScrollView, Text, FlatList} from 'react-native';
import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';
import {useDispatch, useSelector} from 'react-redux';

import Badges from '../Badges/Badges';
import useLocalState from 'src/Hooks/useLocalState';
import {CarouselCard} from 'src/Modules/CommonView/CarouselView';
import {HeaderAndCarouselView} from 'src/Modules/CommonView/HeaderAndCarouselView';
import {BodyText} from 'src/Modules/CommonView/Text';

import {
  updateLocalView,
  updateSelectedLocalLocationId,
} from '../Redux/reducers/local.reducer';

import {Platform} from 'react-native';
import {useUserId} from '../Hooks/reduxHooks';
import DelayedLoad from '../Nav/DelayedLoad';
import {TouchableWithoutFeedback} from 'react-native-gesture-handler';
import {ContinueButton} from 'src/Modules/CommonView/Buttons';
import {addLocationToGuide} from './localFunctions';
import {ordinalSuffixOf} from '../Utils/helpers';
import StarRating from 'src/Modules/Native/StarRating';
import {logCustomAnalyticsEvent} from '../Utils/fireUtils';
import {navigationRef} from '../Nav/navigationHelpers';

const LocalList = ({handleTopPress}) => {
  const {height, width} = useWindowDimensionsSafe();
  const localLocationsList = useSelector(
    (state) => state.local.localLocationsList,
  );

  // Alert.alert(JSON.stringify(localLocationsList));
  const dispatch = useDispatch();

  const [hasClosedBestieTest, setHasClosedBestieTest] = useLocalState(
    'hasClosedBestieTest',
    false,
  );

  const userId = useUserId();

  const cardPress = (location) => {
    dispatch(updateSelectedLocalLocationId(location.id));
    logCustomAnalyticsEvent('local_spot_view', {...location, userId});
    navigationRef.navigate('LocalSiteModal');
    // Alert.alert(JSON.stringify(location));
  };

  const localFavorites = useSelector((state) => state.local.localFavorites);
  const localFilters = useSelector((state) => state.local.localFilters);

  const localCompletionsList = useSelector(
    (state) => state.local?.localCompletionsList,
  );

  const siteCount = localLocationsList?.length || 100;

  var siteNearCount = 0;
  var siteNearCountVisitied = 0;
  var visitedCount = 0;
  var contributtedLocations = 0;
  var pointsEarned = 0;

  const yourSitesAndFavorites = localLocationsList?.filter((location) => {
    const isFavorited = localFavorites?.includes?.(location.id + '');
    const userDidSubmit = userId && location.submitted_by_user_id === userId;
    if (userDidSubmit) {
      contributtedLocations++;
    }
    return isFavorited || userDidSubmit;
  });

  localCompletionsList?.map?.((completions) => {
    pointsEarned += parseInt(completions?.points_earned || 0);
  });

  const yourVisitedSites = localLocationsList?.filter((location) => {
    const completions = localCompletionsList.filter(
      (completion) => completion.location_id == location.id,
    );
    const visited = !!completions?.[0];
    if (visited) {
      visitedCount++;
    }
    if (location.distanceAway < 100) {
      siteNearCount++;
      if (visited) {
        siteNearCountVisitied++;
      }
    }

    return visited;
  });

  useEffect(() => {
    if (hasClosedBestieTest) {
      setHasClosedBestieTest(1);
      navigationRef.navigate('ConfirmModal', {
        titleText: `Let's Roam Local & The Bestie Test`,
        confirmText: `Check Out Let's Roam Local`,
        titleImage: require('src/Images/sightseerIcon.png'),
        titleBodyText: `Imagine your best friend is visiting town, would you recommend the site to your best friend? That is how our users created the 1-3 star guide for Let's Roam Local. One star is something you’d point out as you were walking, 2 star site you’d go out of your way to go to, and 3 star site is something you’d help plan for. Complete free mini-scavenger hunts at each loaction. \n\n There are ${siteCount} FREE Let's Roam Local sites in the world, and ${siteNearCount} nearby. Get exploring!`,
        cancelText: 'Maybe Later',
      });
    }
  }, [hasClosedBestieTest]);

  const localLeaderboard = useSelector((state) => state.local.localLeaderboard);
  var myRank = '25th+';
  localLeaderboard?.map?.((user, index) => {
    if (user?.user_id == userId) {
      myRank = ordinalSuffixOf(index + 1);
    }
  });

  // console.log({localLocationsList});

  return (
    <View
      testID={'LocalList'}
      style={{maxHeight: Platform.OS == 'web' ? height - 100 : null}}>
      <ScrollView testID={'LocalListScrollView'}>
        {!!localFilters?.filter_count && (
          <FlatList
            data={localLocationsList}
            removeClippedSubviews
            keyExtractor={(item) => item.id}
            initialNumToRender={5}
            ListEmptyComponent={() => (
              <View>
                <BodyText>No Results For The Given Filter</BodyText>
                <BodyText>
                  <ContinueButton
                    text={'Clear Filters'}
                    handlePress={() => {
                      <TouchableWithoutFeedback>
                        <BodyText test>Clear Filters</BodyText>
                      </TouchableWithoutFeedback>;
                    }}
                  />
                </BodyText>
              </View>
            )}
            contentContainerStyle={{paddingBottom: 60}}
            renderItem={({item}) => {
              return (
                <CarouselCard
                  key={item.id + item.title}
                  imgSource={{
                    uri: item.photo?.replace?.(
                      './',
                      'https://photos.letsroam.com/',
                    ),
                  }}
                  title={item.name}
                  description={item.guide_description}
                  leftText={`${item.distanceAway} miles away`}
                  handlePress={() => cardPress(item)}
                  cardWidth={width - 20}
                  cardHeight={130}
                  rightText={<StarRating rating={item.rating} />}
                />
              );
            }}
          />
        )}
        {!localFilters?.filter_count && (
          <View testID={'localInto'}>
            <View
              style={{
                backgroundColor: global?.color?.yellow,
                margin: 10,
                padding: 10,
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
              }}>
              <Image
                style={{width: 113, height: 51}}
                source={require('src/Images/three_star.png')}
              />
              <BodyText
                text={`Let's Roam Local`}
                textStyle={{
                  color: 'white',
                  fontSize: 20,
                  fontWeight: 'bold',
                  lineHeight: 24,
                }}
                center
              />
              <View>
                <BodyText
                  textStyle={{
                    color: 'white',
                    marginBottom: 20,
                    lineHeight: 20,
                    marginLeft: 0,
                    marginRight: 0,
                    fontSize: 18,
                  }}>
                  {`Explore the world around you for free with Let's Roam Local. Check out ${siteCount} user submitted and editor approved sites.`}
                </BodyText>
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginBottom: 10,
                  }}>
                  <Text style={{color: 'white', fontSize: 18}}>
                    You have visited{' '}
                  </Text>
                  <TouchableWithoutFeedback style={{}}>
                    <Text
                      style={{
                        color: 'white',
                        lineHeight: 20,
                        textDecorationLine: 'underline',

                        fontSize: 18,
                        fontFamily: global.font.circular,
                      }}>
                      {siteNearCountVisitied || 0} / {siteNearCount} sites
                    </Text>
                  </TouchableWithoutFeedback>

                  <Text style={{color: 'white', fontSize: 18}}>
                    {' '}
                    within 100 miles.
                  </Text>
                </View>
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginBottom: 10,
                  }}>
                  <Text style={{color: 'white', fontSize: 18}}>
                    You have visited{' '}
                  </Text>
                  <TouchableWithoutFeedback style={{}}>
                    <Text
                      style={{
                        color: 'white',
                        lineHeight: 20,
                        textDecorationLine: 'underline',

                        fontSize: 18,
                        fontFamily: global.font.circular,
                      }}>
                      {visitedCount || 0} / {siteCount} sites
                    </Text>
                  </TouchableWithoutFeedback>

                  <Text style={{color: 'white', fontSize: 18}}>
                    {' '}
                    in the world
                  </Text>
                </View>
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginBottom: 10,
                  }}>
                  <Text style={{color: 'white', fontSize: 18}}>
                    You have submitted{' '}
                  </Text>

                  <Text style={{color: 'white', fontSize: 18}}>
                    {contributtedLocations || 0} Sites{' '}
                    <TouchableWithoutFeedback
                      onPress={() => {
                        addLocationToGuide();
                      }}>
                      <Text
                        style={{
                          color: 'white',
                          lineHeight: 20,
                          textDecorationLine: 'underline',
                          marginTop: 2,
                          fontSize: 18,
                          fontFamily: global.font.circular,
                        }}>
                        (add more)
                      </Text>
                    </TouchableWithoutFeedback>
                  </Text>
                </View>
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginTop: -10,
                    marginBottom: 10,
                  }}>
                  <Text style={{color: 'white', fontSize: 18}}>
                    You earned {pointsEarned?.toLocaleString()} Points
                    <TouchableWithoutFeedback
                      onPress={() => {
                        dispatch(updateLocalView('leaderboard'));
                      }}>
                      <Text
                        style={{
                          color: 'white',
                          lineHeight: 20,
                          textDecorationLine: 'underline',
                          marginTop: 6,
                          fontSize: 18,
                          fontFamily: global.font.circular,
                        }}>
                        {' '}
                        ({myRank} on leaderboard)
                      </Text>
                    </TouchableWithoutFeedback>
                  </Text>
                </View>
              </View>
            </View>

            <HeaderAndCarouselView
              title={'3 Star Sites - Worth Planning To See'}
              type={'local_card'}
              cardPress={cardPress}
              intialMaxLength={7}
              data={localLocationsList?.filter(
                (location) => location.rating == 3,
              )}
              carouselIndex={0}
              buttonText={'See Map >'}
              buttonPress={() => {
                handleTopPress('map');
                setHasClosedBestieTest(1);
              }}
            />
            <DelayedLoad delay={20}>
              <HeaderAndCarouselView
                title={'2 Star Sites - Worth A Detour'}
                type={'local_card'}
                intialMaxLength={5}
                cardPress={cardPress}
                carouselIndex={1}
                data={localLocationsList?.filter(
                  (location) => location.rating == 2,
                )}
                buttonText={'See Map >'}
                buttonPress={() => {
                  handleTopPress('map');
                  setHasClosedBestieTest(1);
                }}
              />
            </DelayedLoad>
            <DelayedLoad delay={2000}>
              <HeaderAndCarouselView
                title={'1 Star Sites - Worth A Stop'}
                type={'local_card'}
                intialMaxLength={5}
                carouselIndex={2}
                cardPress={cardPress}
                data={localLocationsList?.filter(
                  (location) => location.rating == 1,
                )}
                buttonText={'See Map >'}
                buttonPress={() => {
                  handleTopPress('map');
                  setHasClosedBestieTest(1);
                }}
              />

              <HeaderAndCarouselView
                title={'Closest To You'}
                type={'local_card'}
                intialMaxLength={5}
                carouselIndex={3}
                cardPress={cardPress}
                data={localLocationsList}
                buttonText={'See Map >'}
                showStars
                buttonPress={() => {
                  handleTopPress('map');
                  setHasClosedBestieTest(1);
                }}
              />
              {!!yourSitesAndFavorites?.[0] && (
                <HeaderAndCarouselView
                  title={'Your Submitted Sites & Favorites'}
                  type={'local_card'}
                  intialMaxLength={5}
                  carouselIndex={4}
                  cardPress={cardPress}
                  data={yourSitesAndFavorites}
                  buttonText={'See Map >'}
                  buttonPress={() => {
                    handleTopPress('map');
                    setHasClosedBestieTest(1);
                  }}
                />
              )}
              {!!yourVisitedSites?.[0] && (
                <HeaderAndCarouselView
                  title={'Your Visitied Sites'}
                  type={'local_card'}
                  intialMaxLength={5}
                  carouselIndex={5}
                  cardPress={cardPress}
                  data={yourVisitedSites}
                  buttonText={'See Map >'}
                  buttonPress={() => {
                    handleTopPress('map');
                    setHasClosedBestieTest(1);
                  }}
                />
              )}
              <BodyText
                text={'Complete Challenges To Earn Prizes'}
                textStyle={{marginTop: 20, fontWeight: '700'}}
              />
              <Badges showOnlyType={'local'} />
              <View style={{width: 200, height: 200}} />
            </DelayedLoad>
          </View>
        )}
      </ScrollView>
    </View>
  );
};

export default LocalList;
